import React, { useState, useContext } from 'react';
import CloseButtonDialog from "App/components/CloseButtonDialog";
import DialogActions from '@material-ui/core/DialogActions';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import Button from '@material-ui/core/Button';
import Switch from '@material-ui/core/Switch';
import TextField from '@material-ui/core/TextField';
import { withStyles } from "@material-ui/core/styles";
import {CertificadosContext} from "App/Administracion/Certificados/store";
import {LayoutContext} from "App/Layout/store";
import { getBase64 } from 'App/Helpers/Actions';
import axios from 'axios';
import _ from 'underscore';

const styles = theme => ({
  table: {
    marginTop: 30,
  },
  gridContainer: {
    paddingRight: 30,
    marginTop: "0.1px"
  },
  borderRed: {
    borderStyle: "solid",
    marginTop: "0.1px",
    padding: 10,
    borderColor: "red"
  },
  labelPaddingTop: {
    paddingTop: "10px"
  }
});

function CargarCertificado(props) {
    const certificadosContext = useContext(CertificadosContext);
    var layoutContext = useContext(LayoutContext);
    const handleToggleModal = ()=> {
        certificadosContext.dispatch({type:"toggleCargarCertificado"});
        certificadosContext.dispatch({type:"reset"});
    }
    const { classes } = props;

    const [ remitenteDefecto, setRemitenteDefecto ] = useState(true);

    function onFileInputChange(event) {
        event.preventDefault();
        const _validFileExtensions = [".pfx", ".cert"];
        var fileInput = event.target;
        var file = fileInput.files[0];

        if(file != null) {
            var sFileName = file.name;
            var blnValid = false;
            for (var j = 0; j < _validFileExtensions.length; j++) {
                var sCurExtension = _validFileExtensions[j];
                if (sFileName.substr(sFileName.length - sCurExtension.length, sCurExtension.length).toLowerCase() == sCurExtension.toLowerCase()) {
                    blnValid = true;
                    break;
                }
            }
            
            if (!blnValid) {
                alert("Sólo se aceptan archivos de certificado");
                return false;
            }

            getBase64(file, (archivoBase64)=> {
                archivoBase64 = archivoBase64.substr(archivoBase64.indexOf(',') + 1);
                certificadosContext.dispatch({type:"loadCertificado", archivoBase64});
            }, (error)=> {
                console.log(error);
                certificadosContext.dispatch({type:"loadCertificado", archivoBase64: null});
            });
        } else {
            certificadosContext.dispatch({type:"loadCertificado", archivoBase64: null});
        }
    }

    function GuardarCertificado() {
        if(certificadosContext.state.archivoBase64 != null) {
            var data = {
                archivo: certificadosContext.state.archivoBase64,
                clave: certificadosContext.state.claveCertificado
            }
            axios.post('/api/Administracion/Remitente/Crear' + (remitenteDefecto ? "/Default" : ""), data).then(()=> {
                alert("Certificado cargado con éxito");
                handleToggleModal();
                if(props.getCerts){
                    props.getCerts();
                }
            }).catch((e)=> {
                console.log(e.response.data.Mensaje);
                /*alert(e.response.data.Mensaje)*/;
            })
        } else {
            alert("No ha sido cargado el certificado al formulario");
        }
    }

    function toggleRemitenteDefecto() {
        setRemitenteDefecto(!remitenteDefecto);
    }

    function onChangeClaveCertificado(e) {
        certificadosContext.dispatch({type:"changeClaveCertificado", claveCertificado: e.target.value});
    }

    const content = (
        <Grid container direction="column">
            <Grid item xs={12} sm>
                <Button variant="contained"
                    containerElement='label'
                    label='My Label'>
                    <input onChange={onFileInputChange} type="file" />
                </Button>
            </Grid>
            <Grid item xs={12} sm>
                <TextField
                  label="Contraseña certificado"
                  fullWidth
                  type="password"
                  value={certificadosContext.state.claveCertificado}
                  onChange={onChangeClaveCertificado}
                  margin="normal"
                />
            </Grid>
            <Grid item xs={12} sm>
            <Typography>
                <Switch
                    checked={remitenteDefecto}
                    onChange={toggleRemitenteDefecto}
                    color="primary"
                    /> Remitente por defecto</Typography>
            </Grid>
        </Grid>
    );

    const footer = (
        <DialogActions>
        <Button onClick={handleToggleModal} color="primary">
            Cancelar
        </Button>
        <Button onClick={()=> { GuardarCertificado(); }} color="primary" autoFocus>
            Guardar
        </Button>
        </DialogActions>
    );

    return (
        <div>
            <CloseButtonDialog open={certificadosContext.state.openCargarCertificado} onClose={handleToggleModal} closeButton title={"Cargar certificado"} content={content} footer={footer} fullWidth size="sm" />
        </div>
    );
}

export default withStyles(styles)(CargarCertificado);